// Sections the site owner adds (issue #72): the screens for their entries and the manager on Content types.
export const sectionsEn = {
  'media.usage.custom': 'Custom section',
  'sections.entry': 'Entry',
  'sections.entries': 'Entries',
  'sections.notFound': 'This section does not exist (any more).',
  'sections.summaryHint': 'Shown on cards and as the default search description.',
  'sections.price': 'Price line',
  'sections.priceHint': 'Free text, e.g. “From Rp 150.000”. Leave empty for none.',
  'sections.publishDateHint': 'Shown on the list and used to order it, newest first. Empty = when first published.',
  'sections.add': 'Add section',
  'sections.add.title': 'Add a section',
  'sections.add.hint': 'A section is a group of pages of its own, such as Portfolio, Services or Menu. Give it a name in each language.',
  'sections.add.template': 'Layout',
  'sections.add.address': 'Address on the website',
  'sections.add.addressHint': 'The section will be at /<address>. Lowercase letters, numbers and hyphens.',
  'sections.add.fromName': 'Fill from name',
  'sections.add.submit': 'Add section',
  'sections.template.catalogue': 'Catalogue: categories with items (e.g. a menu or a product range)',
  'sections.template.cards': 'Cards: a simple ordered list (e.g. services or team)',
  'sections.template.articles': 'Articles: a dated list, newest first (e.g. news or events)',
  'sections.added': 'Section added',
  'sections.custom': 'Your own',
  'sections.open': 'Open',
  'sections.openCategories': 'Categories',
  'sections.address': 'Address',
  'sections.address.title': 'Change the address of {name}',
  'sections.address.hint': 'The old address keeps working: visitors and search engines are sent to the new one.',
  'sections.address.submit': 'Change address',
  'sections.address.saved': 'Address changed',
  'sections.delete': 'Delete',
  'sections.delete.title': 'Delete {name}?',
  'sections.delete.body': 'The section leaves the website and the menu. Its {count} entries are kept, and you can restore it from “Deleted sections” below.',
  'sections.deleted': 'Section deleted',
  'sections.restore': 'Restore',
  'sections.restored': 'Section restored',
  'sections.deletedTitle': 'Deleted sections',
  'sections.deletedHint': 'Restoring brings the section and everything in it back.',
  'sections.limit': 'You can add up to {max} sections.',
  'sections.locked': 'Your plan does not include adding sections of your own.',
} as const

export const sectionsId: Record<keyof typeof sectionsEn, string> = {
  'media.usage.custom': 'Bagian buatan sendiri',
  'sections.entry': 'Entri',
  'sections.entries': 'Entri',
  'sections.notFound': 'Bagian ini tidak ada (lagi).',
  'sections.summaryHint': 'Tampil di kartu dan menjadi deskripsi pencarian bawaan.',
  'sections.price': 'Baris harga',
  'sections.priceHint': 'Teks bebas, mis. “Mulai Rp 150.000”. Kosongkan jika tidak ada.',
  'sections.publishDateHint': 'Tampil di daftar dan menentukan urutan, terbaru dahulu. Kosong = saat pertama kali terbit.',
  'sections.add': 'Tambah bagian',
  'sections.add.title': 'Tambah bagian',
  'sections.add.hint': 'Bagian adalah kelompok halaman tersendiri, seperti Portofolio, Layanan, atau Menu. Beri nama dalam setiap bahasa.',
  'sections.add.template': 'Tata letak',
  'sections.add.address': 'Alamat di situs web',
  'sections.add.addressHint': 'Bagian akan berada di /<alamat>. Huruf kecil, angka, dan tanda hubung.',
  'sections.add.fromName': 'Isi dari nama',
  'sections.add.submit': 'Tambah bagian',
  'sections.template.catalogue': 'Katalog: kategori berisi item (mis. menu atau rangkaian produk)',
  'sections.template.cards': 'Kartu: daftar berurutan sederhana (mis. layanan atau tim)',
  'sections.template.articles': 'Artikel: daftar bertanggal, terbaru dahulu (mis. berita atau acara)',
  'sections.added': 'Bagian ditambahkan',
  'sections.custom': 'Buatan sendiri',
  'sections.open': 'Buka',
  'sections.openCategories': 'Kategori',
  'sections.address': 'Alamat',
  'sections.address.title': 'Ubah alamat {name}',
  'sections.address.hint': 'Alamat lama tetap berfungsi: pengunjung dan mesin pencari diarahkan ke alamat baru.',
  'sections.address.submit': 'Ubah alamat',
  'sections.address.saved': 'Alamat diubah',
  'sections.delete': 'Hapus',
  'sections.delete.title': 'Hapus {name}?',
  'sections.delete.body': 'Bagian ini hilang dari situs web dan menu. {count} entrinya tetap disimpan, dan Anda dapat memulihkannya dari “Bagian yang dihapus” di bawah.',
  'sections.deleted': 'Bagian dihapus',
  'sections.restore': 'Pulihkan',
  'sections.restored': 'Bagian dipulihkan',
  'sections.deletedTitle': 'Bagian yang dihapus',
  'sections.deletedHint': 'Memulihkan mengembalikan bagian beserta seluruh isinya.',
  'sections.limit': 'Anda dapat menambah hingga {max} bagian.',
  'sections.locked': 'Paket Anda tidak mencakup penambahan bagian buatan sendiri.',
}
